const { withDefaults } = require('react-bem-helper');

module.exports = withDefaults({
  outputIsString: true,
});
